/* eslint-disable no-unused-expressions, no-magic-numbers */

import ResizeTracker from 'utils/ResizeTracker';

class Flex {

    /**
     * @param {HTMLElement} element
     * @param {Object} options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._elements = {
            window: this._element.querySelector('.flex__table'),
            cards: [...this._element.querySelectorAll('[role="tabpanel"]')],
            tabs: [...this._element.querySelectorAll('[role="tab"]')],
            columns: [...this._element.querySelectorAll('.flex__column')],
            notifications: [...this._element.querySelectorAll('.flex__notification')]
        };

        this._state = {
            currentTab: 0,
            isMobile: false,
            mobileWidth: 768,
            currentCategory: 'beforeAowAge'
        };

        this._handleResize = this._handleResize.bind(this);

        this._addEventListeners();
    }

    /**
     * Set all the event listeners for the notification
     */
    _addEventListeners() {
        this._resizeTracker = new ResizeTracker();

        this._resizeTracker.init(
            { element: window },
            this._handleResize
        );

        this._handleResize();

        this._elements.columns.forEach((element, index) => {
            element.addEventListener('click', event => this._switchTabs(event, index));
        });
    }

    _handleResize() {
        const isMobile = document.body.offsetWidth < this._state.mobileWidth;
        this._state.isMobile = isMobile;
        isMobile && this._switchMobileTabs();
        this._state.currentTab = isMobile ? this._state.currentTab : 0;
        !isMobile && this._handleCurrentCard();
    }


    _handleCurrentCard() {
        this._elements.tabs.forEach((tab, index) => {
            const isCurrent = index === this._state.currentTab;
            this._state.currentCategory = isCurrent ? tab.getAttribute('data-type') : this._state.currentCategory;
            tab.setAttribute('aria-selected', isCurrent);
        });

        this._elements.cards.forEach((card, index) => {
            card.setAttribute('aria-hidden', index !== this._state.currentTab);
        });

        this._elements.notifications.forEach(notification => {
            const category = notification.getAttribute('data-type');
            const isCurrent = category === this._state.currentCategory;
            notification.setAttribute('aria-hidden', !isCurrent);
        });

        this._element.setAttribute('data-current', this._state.currentTab);
    }

    _switchTabs(event, index) {
        event.preventDefault();
        // eslint-disable-next-line curly
        if (this._state.isMobile) return;
        this._state.currentTab = index;
        this._handleCurrentCard();
    }

    _switchMobileTabs() {
        this._elements.tabs.forEach(tab => {
            tab.setAttribute('aria-selected', true);
        });

        this._elements.cards.forEach(card => {
            card.setAttribute('aria-hidden', false);
        });

        this._elements.notifications.forEach(notification => {
            notification.setAttribute('aria-hidden', false);
        });

    }
}

// Exports
export default Flex;
/* eslint-enable */
